import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/security/auth.service';
import { Email, EmailTags, EmailTemplates } from '../models/email.model';
import { EmpresaService } from './empresa.service';
import { UserDialogService } from '../components/user-dialog/user-dialog.service';
import { UserDialogType } from '../components/user-dialog/user-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class EnviarEmailService {
  constructor(
    private afs: AngularFirestore,
    private auth: AuthService,
    private empresaSvc: EmpresaService,
    private userDialogService: UserDialogService
  ) {}

  getTemplates() {
    return this.afs.doc<string>(`catalogos/correos-templates`).valueChanges().pipe(take(1)).toPromise();
  }

  /**
   *
   * @param content HTML string that will be replaced in the html text
   * @param title String for the title
   * @param templateName  Template name to be used. Seee EmailTemplates ENUM
   */
  async composeEmail(
    to: string[],
    subject: string,
    contentHTML: string,
    title: string,
    templateName: EmailTemplates,
    from?: any,
    replyTo?: string[],
    attachments?: any[],
    bcc?: string[]
  ) {
    if (!attachments) {
      attachments = [];
    }
    const empresa = await this.auth.empresaSelGlobal$.pipe(take(1)).toPromise();
    // to.push('rodrigo@applicateya.com');
    // to.push('samuel@applicateya.com');
    console.log('Parametros', to, subject, title, templateName, attachments);
    console.log('from line', from);

    // Obteniendo los datos de Empresa

    // console.log('Empresa desde funcion composeEmail', this.empresa, this.empresa.alias);

    // Obteniendo los Templates
    const templates = await this.getTemplates();
    if (!templates[templateName]) {
      this.userDialogService.alert({
        titulo: 'Error',
        mensaje: 'No existe el template de correo solicitado',
        tipo: UserDialogType.OK,
      });

      return;
    }

    let html = templates[templateName];
    html = html
      .replace(EmailTags.CONTENT, contentHTML)
      .replace(EmailTags.TITLE, title)
      .replace(EmailTags.COMPANY, empresa.nombre);

    const emailObj: Email = {
      message: {
        html,
        subject,
        attachments,
      },
      to,
    };

    if (from) {
      emailObj.from = from;
    }
    if (replyTo) {
      emailObj.replyTo = replyTo;
    }
    if (bcc) {
      emailObj.bcc = bcc;
    }

    console.log('Email OBJ', emailObj);

    const resp = await this.crearRegistroEmail(emailObj);
    if (resp) {
      console.log('Registro Email Creado...');
    }
  }

  /**
   *
   * @param emailRecord typeof Email.
   * Al enviar este parametro, se  escribirá en la BD
   * y en un FirebaseFunction en automático se hará el envìo
   */
  async crearRegistroEmail(emailRecord: Email) {
    return this.afs.collection<Email>('correos').add(emailRecord);
  }
}
